import { FormattedMessage } from 'react-intl'
import errorImage from '@static/images/dialog/error-dialog.png'

import './ErrorDatasetInfo.css'

interface ErrorDatasetInfoProps {
  error: Error | null
}

export default function ErrorDatasetInfo({ error }: ErrorDatasetInfoProps) {
  return (
    <div id="error-dataset-info" role="alert">
      <section className="wrapper">
        <img src={errorImage} alt="" aria-hidden="true" />
        <h1>
          <FormattedMessage id="dataset.error.title" />
        </h1>
        <p>
          <FormattedMessage id="dataset.error.description" />
        </p>
        {__DEV__ && error?.message && (
          <pre className="error-stack">{error.message}</pre>
        )}
      </section>
    </div>
  )
}
